exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--c-dark-blue:#010122;--c-footer-bg:#4c4d64;--c-page-background:#a6a6a6;--c-grey:#cec8c8;--c-error:#dc3545;--c-success:#28a745}*{box-sizing:border-box}body{overflow:hidden}a,h1,h2,h3{font-family:Bodoni Moda,serif}h1{font-size:3.4rem;line-height:0}h2{font-size:1.2rem}h3{font-size:2.2rem;margin-bottom:.5rem}h4{text-decoration:underline}button,h4,p{margin:0 0 10px}button,p{font-family:Oswald,sans-serif;font-size:1.2rem;line-height:1.5rem}button{cursor:pointer}hr{border-color:grey;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/styles/global.css
// module id = 282
// module chunks = 0